var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsdtLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C43.4633 0 56 12.5367 56 28C56 43.4633 43.4627 56 28 56C12.5373 56 0 43.4666 0 28C0 12.5334 12.535 0 28 0Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4558 24.2695V20.1042H40.9808V13.7577H15.0439V20.1042H24.57V24.2661C16.828 24.6217 11.0068 26.155 11.0068 27.9918C11.0068 29.8286 16.8308 31.3619 24.57 31.7197V45.0617H31.458V31.7186C39.186 31.3619 44.9955 29.8297 44.9955 27.9946C44.9955 26.1595 39.186 24.6273 31.458 24.2706L31.4558 24.2695ZM31.458 30.5885V30.5851C31.2637 30.5975 30.2652 30.6574 28.042 30.6574C26.2646 30.6574 25.0141 30.607 24.5734 30.584V30.5896C17.7336 30.2867 12.628 29.0955 12.628 27.6703C12.628 26.2451 17.7341 25.0557 24.5734 24.7522V29.403C25.0214 29.4338 26.3027 29.5094 28.0712 29.5094C30.1952 29.5094 31.2632 29.4209 31.4592 29.403V24.7522C38.2856 25.0563 43.3793 26.2485 43.3793 27.6687C43.3793 29.0888 38.2833 30.2816 31.4592 30.5857",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdtLg);
export default __webpack_public_path__ + "static/media/icon-usdt-lg.eda9c2eb.svg";
export { ForwardRef as ReactComponent };